import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";

const links = [
  { label: "Collection", target: "shop" },
  { label: "Atelier", target: "manifesto" },
  { label: "Contact", target: "footer" },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Nav = () => {
  const { count, setOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.19, 1, 0.22, 1], delay: 0.1 }}
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled
          ? "bg-aak-bg/80 backdrop-blur-xl border-b border-aak-border py-4"
          : "bg-transparent border-b border-transparent py-6"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => scrollTo("hero")}
          className="font-serif text-3xl md:text-4xl tracking-tight leading-none text-aak-fg"
        >
          AAK
          <span className="text-aak-primary">.</span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.target}
              data-testid={`nav-link-${l.target}`}
              onClick={() => scrollTo(l.target)}
              className="link-underline text-xs uppercase tracking-[0.2em] text-aak-fg/80 hover:text-aak-fg"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="cart-toggle-btn"
          onClick={() => setOpen(true)}
          className="relative flex items-center gap-2 group"
          aria-label="Open cart"
        >
          <span className="hidden sm:block text-xs uppercase tracking-[0.2em] text-aak-fg/80 group-hover:text-aak-fg transition-colors">
            Bag
          </span>
          <ShoppingBag className="w-5 h-5 text-aak-fg" strokeWidth={1.4} />
          {count > 0 && (
            <span
              data-testid="cart-count"
              className="absolute -top-2 -right-2 min-w-[18px] h-[18px] px-1 flex items-center justify-center bg-aak-primary text-aak-bg text-[10px] font-medium"
            >
              {count}
            </span>
          )}
        </button>
      </div>
    </motion.header>
  );
};
